import { render, staticRenderFns } from "./PlayRenderer.vue?vue&type=template&id=67434634&scoped=true&"
import script from "./PlayRenderer.vue?vue&type=script&lang=js&"
export * from "./PlayRenderer.vue?vue&type=script&lang=js&"
import style0 from "./PlayRenderer.vue?vue&type=style&index=0&id=67434634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67434634",
  null
  
)

export default component.exports